import { h, Host } from "@stencil/core";
/**
 * @slot (default) - content of the tab
 * @slot label - can be used instead of the `name` attribute if a tab button should render HTML instead of plain text
 */
export class Tab {
    constructor() {
        this.name = "";
        this.tabId = "";
        this.anchorNavigation = false;
        this.active = false;
        this.hasSliderInTab = undefined;
    }
    domNode;
    /* eslint-disable-next-line @stencil-community/required-jsdoc */
    tabNameChange;
    emitTabNameChangeEvent() {
        this.tabNameChange.emit({ tabId: this.tabId, tabName: this.name });
    }
    setActiveTab(event) {
        const eTarget = event.target;
        // @ts-expect-error Check for typing
        if (this.domNode.parentElement.parentElement.isSameNode(eTarget)) {
            this.active = event.detail === this.tabId;
        }
        else if (eTarget.contains(this.domNode) && eTarget.closest("ux-form-steps")) {
            this.active = event.detail === this.tabId;
        }
    }
    componentWillLoad() {
        this.hasSliderInTab = this.domNode.querySelector("ux-slider") !== null;
    }
    render() {
        return (h(Host, { key: '0e6faa4616dae88f88417d3358a68920bc8248e5', role: "tabpanel", "aria-hidden": this.active ? "false" : "true", class: {
                ["ux-tab"]: true,
                ["is-active"]: this.active,
                ["ux-tab--anchor-navigation"]: this.anchorNavigation,
                ["ux-tab--with-slider"]: this.hasSliderInTab
            } }, h("div", { key: '4daf697092fe3129ad0b802b8bf367e5777d7779', style: { display: "none" } }, h("slot", { key: '22a7d3a062d5ac59fc55e3088e5ddd44fda193a8', name: "label" })), this.anchorNavigation && h("div", { key: '296234fccf64880a50010a962fcc217de13e27d7', class: "ux-tab__margin-collapse-guard" }), h("slot", { key: '9bea6605616fbfd4535c212b06f24de81d4ffa6e' })));
    }
    static get is() { return "ux-tab"; }
    static get originalStyleUrls() {
        return {
            "$": ["tab.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tab.css"]
        };
    }
    static get properties() {
        return {
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets the name for the corresponding tab-button"
                },
                "attribute": "name",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "tabId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Sets ID for Tab"
                },
                "attribute": "tab-id",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "anchorNavigation": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "prop that will be set automatically by the ux-tab-container if it\nhas the anchor-navigation prop. In this case, all tabs will be visible and\nwill be displayed one after the other"
                },
                "attribute": "anchor-navigation",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "active": {},
            "hasSliderInTab": {}
        };
    }
    static get events() {
        return [{
                "method": "tabNameChange",
                "name": "uxTabNameChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "domNode"; }
    static get watchers() {
        return [{
                "propName": "name",
                "methodName": "emitTabNameChangeEvent"
            }];
    }
    static get listeners() {
        return [{
                "name": "uxActiveTabSet",
                "method": "setActiveTab",
                "target": "document",
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=tab.js.map
